import { MovementDataStore } from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { EntityHistory } from '@skinsoft/ui';
import { Component } from 'vue-property-decorator';

import { toHistoryRecord$ } from '../../serializer/history';

@Component({
    components: {
        sEntityHistory: EntityHistory,
    },
    props: ['targetRouteName'],
    template: require('./movement-history.html'),
})
export class MovementHistory extends ReactiveVue {
    public $movementDataStore: MovementDataStore;
    public historyStates = MovementDataStore.historyStates;
    public serializer = toHistoryRecord$;
    public sortFields = MovementDataStore.sortFields;
    public targetRouteName;
}
